import {Button, ButtonProps, Radio, RadioProps, useMediaQuery} from "@chakra-ui/react";
import React, { useMemo } from "react";

const APRadio = ({ children, ...others }: RadioProps) => {
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");
  return (
    <Radio {...others} sx={{zoom: isLargeScreen ? 1.26 : 1}}>
      {children}
    </Radio>
  );
};

export default APRadio;
